import React from "react";
import { Redirect, Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
// Pages
import Splash from "pages/Splash/Splash";
import Home from "pages/Home/Home";
import Tips from "pages/Tips/Tips";
import Tutorial from "pages/Tutorial/Tutorial";
import Credits from "pages/Credits/Credits";
import Story from "pages/Story/Story";
import Create from "pages/Game/Create/Create";
import Join from "pages/Game/Join/Join";
import WaitingRoom from "pages/Game/WaitingRoom/WaitingRoom";
import Board from "pages/Game/Board/Board";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "theme/index.scss";

// hooks
import { useApp } from "App.hook";

const App: React.FC = () => {
  useApp();

  return (
    <IonRouterOutlet>
      {/* Game routes */}
      <Route path="/game/create" component={Create} />
      <Route path="/game/join" component={Join} />
      <Route path="/game/waiting-room" component={WaitingRoom} />
      <Route path="/game/board" component={Board} />
      {/* Menu routes */}
      <Route path="/home" component={Home} />
      <Route path="/tips" component={Tips} />
      <Route path="/tutorial" component={Tutorial} />
      <Route path="/credits" component={Credits} />
      <Route path="/story" component={Story} />
      <Route path="/" exact component={Splash} />
      <Redirect to="/" />
    </IonRouterOutlet>
  );
};

export default App;
